import React from "react";
// import BreadCrumb from '../../../../Components/Utils/Breadcrumbs';
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import Modal from "../../../../Components/Utils/AttachmentView";
import { useState, useEffect } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import NuDate from "../../../../Components/Utils/NuDate";
import FilesView from "../../../../Components/Utils/FilesView";
import CommonComments from "../../../../Components/Utils/commonComments";

const ViewShipmentTracking = () => {
  const { shipmentTrackingViewId } = useParams();
  const location = useLocation();
  const locationData = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState(locationData || null);

  useEffect(() => {
    if (!locationData && shipmentTrackingViewId) {
      axiosInstance
        .get(`/shipping/${shipmentTrackingViewId}`)
        .then((res) => {
          setData(res.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [shipmentTrackingViewId, locationData]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }
  if (!data) {
    return (
      <div className="w-full h-[calc(100vh-145px)] flex items-center justify-center bg-white rounded-lg shadow-lg">
        <div className="flex flex-col items-center gap-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#579BB1]"></div>
          <p className="text-sm font-medium text-gray-500">Loading shipment details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full py-2 px-2 lg:px-4 mb-3 relative">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Shipment Tracking",
              link: "/shipping/shipment-tracking",
            },
            {
              name: "View Shipment Tracking",
            },
          ]}
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link
            to={"/shipping/shipment-tracking"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/shipping/shipment-tracking/edit/${data?.shippingId || ""}`}
            state={{
              data: data,
              from: `/shipping/shipment-tracking/view/${data?.shippingId || ""}`,
              pageIndex,
              searchQuery,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div>
      <div className="w-full mx-auto flex flex-col lg:flex-row gap-4 lg:h-[calc(100vh-145px)] overflow-y-auto p-2 text-[#111537]">

        <div className="w-full lg:w-[70%] bg-white rounded-lg drop-shadow-lg py-1 flex flex-col overflow-hidden">

          <div className="w-[98%] bg-white px-2 mx-2 border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
            <div className="grid items-center px-2 w-full sm:w-[70%]">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-full">
                <p className="">{data?.ref}</p>
              </div>
              <div className="flex gap-4">
                <p className="text-xs text-[#111537]">
                  Date :{" "}
                  {data?.createdAt ? (
                    <NuDate
                      value={data?.createdAt}
                      format="DD-MMM-YYYY, hh:mm A"
                    />
                  ) : (
                    "N/A"
                  )}
                </p>
              </div>
            </div>
            <div className="grid gap-2 justify-start sm:justify-end w-full sm:w-[40%]">
              <div className="border rounded-md sm:mr-3 border-[#579BB1] text-xs inline-flex w-auto flex-shrink-0 justify-center">
                <p className="bg-white text-black p-1 rounded-l-md">
                  Status{" "}
                </p>
                <p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md">
                  {" "}
                  {data?.shipmentStatus || "None"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto p-2 pb-4">
            <p className="w-full text-xs font-semibold text-[#111537]">
              Booking Details
            </p>

            <div className="w-full flex flex-wrap border border-gary mt-2 px-2 rounded-lg">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-8">
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Booking Date
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279]">
                    :{" "}
                    {(data?.bookingDate &&
                      NuDate({
                        value: data?.deliveryDatebyPO,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Delivery Date by PO
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.deliveryDatebyPO &&
                      NuDate({
                        value: data?.deliveryDatebyPO,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Shipped On
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.shippedOn &&
                      NuDate({
                        value: data?.shippedOn,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Shipping Method
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    : {data?.modeOfShipment || "None"}
                  </p>
                </div>
                {/*   <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Shipped On</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.shippedOn || '-'}</p>
                  </div> */}
                {/* <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Shipment Status</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.shipmentStatus || '-'}</p>
                  </div> */}

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Shipment Bill Number
                  </p>
                  <p className="w-1/2 py-2 text-xs   text-[#606279] ">
                    {" "}
                    : {data?.shipmentBill || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Permit Required?
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    : {data?.permitReq === true ? "Yes" : "No" || "-"}
                  </p>
                </div>

                {/*   <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>insuracePolicyNumber</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.insuracePolicyNumber || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>insurance Provider</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.insuranceProvider || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Insurance Type</p>
                    <p className='w-1/2 py-2   text-xs  text-[#606279] '>: {data?.insuranceType || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Coverage Start Date</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.coverageStartDate || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Coverage End Date</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.coverageEndDate || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Coverage Amount</p>
                    <p className='w-1/2 py-2   text-xs  text-[#606279] '>: {data?.coverageAmount || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Insurance Premium</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279] '>: {data?.insurancePremium || '-'}</p>
                  </div>
                    <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Claim Contact Info</p>
                    <p className='w-1/2 py-2 font-medium  text-xs  text-[#606279] '>: {data?.claimContactInfo || '-'}</p>
                  </div> */}
              </div>
            </div>
            <p className="w-full pt-4 3x-4  text-xs font-semibold text-[#111537]">
              Tracking Details
            </p>

            <div className='w-full flex flex-wrap   border border-gary mt-2 px-2 rounded-lg "'>
              <div className=" w-full grid grid-cols-1 sm:grid-cols-2 gap-x-8 ">
                {/* <div className='w-full flex px-2'>
                    <p className='w-1/2 py-2 text-xs font-medium text-[#111537]'>Tracking Url</p>
                    <p className='w-1/2 py-2  text-xs  text-[#606279]  truncate'>: {data?.trackingUrl || '-'}</p>
                  </div> */}
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    ETD
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.ETD &&
                      NuDate({ value: data?.ETD, format: "DD-MM-YYYY" })) ||
                      "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    ETA
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.ETA &&
                      NuDate({ value: data?.ETA, format: "DD-MM-YYYY" })) ||
                      "-"}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Estimated Shipping Cost
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    : {data?.ESC || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Actual Shipping Cost
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.ASC || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Actual Arrival Date
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    :{" "}
                    {(data?.actualArrivalDate &&
                      NuDate({
                        value: data?.actualArrivalDate,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>
              </div>
            </div>
            <p className="w-full pt-4 3x-4  text-xs font-semibold text-[#111537]">
              Shipment Received Details
            </p>

            <div className='w-full flex flex-wrap   border border-gary mt-2 px-2 rounded-lg "'>
              <div className=" w-full grid sm:grid-cols-2 gap-x-8 ">
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Received Date
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.receiveDate &&
                      NuDate({
                        value: data?.receiveDate,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Delivery Person Name
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.deliveryPersonName2 || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Identity Type
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.identityType2 || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Identity Number
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.identityNumber2 || "-"}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Vehicle Type
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.vehicleType2 || "-"}
                  </p>
                </div>

                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Vehicle Number
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.vehicleNumber2 || "-"}
                  </p>
                </div>
                {/* <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Shipment Status
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.shipmentStatus2 || "-"}
                  </p>
                </div> */}
              </div>
              {/* {(data?.attachments2 || data?.attachments) && Array.isArray(data?.attachments2 || data?.attachments) && (data?.attachments2 || data?.attachments)?.length > 0 && (
                <div className="w-full px-2 py-2 border-t border-slate-200 mt-2">
                  <p className="text-xs font-medium text-[#111537] mb-2">
                    Attachments
                  </p>
                
                </div>
              )} */}
            </div>
            <p className="w-full pt-4 3x-4  text-xs font-semibold text-[#111537]">
              Delivery Details
            </p>

            <div className='w-full flex flex-wrap   border border-gary mt-2 px-2 rounded-lg "'>
              <div className=" w-full grid sm:grid-cols-2 gap-x-8 ">
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Delivery Date
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    :{" "}
                    {(data?.deliveryDate &&
                      NuDate({
                        value: data?.deliveryDate,
                        format: "DD-MM-YYYY",
                      })) ||
                      "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Delivery Person Name
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.deliveryPersonName || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Identity Type
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.identityType || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Identity Number
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.identityNumber || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Vehicle Type
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.vehicleType || "-"}
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                    Vehicle Number
                  </p>
                  <p className="w-1/2 py-2  text-xs  text-[#606279] ">
                    {" "}
                    : {data?.vehicleNumber || "-"}
                  </p>
                </div>
              </div>
              {data?.deliveryAttachments && Array.isArray(data?.deliveryAttachments) && data?.deliveryAttachments?.length > 0 && (
                <div className="w-full px-2 py-2 border-t border-slate-200 mt-2">
                  <p className="text-xs font-medium text-[#111537] mb-2">
                    Delivered Items Attachments
                  </p>
                  <div className="w-full flex gap-2 flex-wrap">
                    {data?.deliveryAttachments.map((imgs, idx) => (
                      <FilesView fileView={imgs} key={idx} />
                    ))}
                  </div>
                </div>
              )}
            </div>


            <div className="flex gap-4 mt-4">
              <div className="w-full ">
                <p className="  text-xs font-medium text-[#111537] p-1">
                  Tracking Url
                </p>
                <div className="  border border-gary  h-12 overflow-y-scroll rounded-lg items-center">
                  <p className="  text-xs p-2 break-words text-[#606279]">
                    {data?.trackingUrl || "-"}
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="flex gap-4 mt-4">
      <div className="w-[50%] ">
          <p className=" p-1 text-xs font-medium text-[#111537]">
          Shipment Tracking Attachments
            </p>
          <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
     

          <div className="w-full flex gap-2 flex-wrap ">
          {data?.attachments &&
                                    data?.attachments.map((imgs, idx) => {
                                        console.log('img', imgs);
                                        return (
                    <FilesView fileView={imgs} key={idx}/>

                                           
                                        );
                                    })}
                               
                            </div>
                          
                        </div> 
                      
          </div> 
          </div> */}
          </div>
        </div>
        <div className="w-full lg:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 flex flex-col overflow-hidden">
          <div className="h-full overflow-y-auto p-2">
            <div className="w-full grid  border border-gary   rounded-lg ">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">
                  Shipping Reference{" "}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  YPR
                </p>
                <p className="w-[65%] py-2 truncate text-xs  text-[#606279] ">
                  : {data?.prRef || "-"}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  PO
                </p>
                <p className="w-[65%] py-2 truncate  text-xs  text-[#606279] ">
                  : {data?.poRef || "-"}
                </p>
              </div>
              <div className="w-full flex px-2">
                <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Agent
                </p>
                <p className="w-[65%] py-2 truncate text-xs  text-[#606279] ">
                  : {data?.agentName || "-"}
                </p>
              </div>
            </div>

            {/* Attachments */}
            <div className="w-full mt-4 border border-gray rounded-lg overflow-hidden">
              <p className="text-xs text-white font-medium bg-baseColor-primary p-2">
                Attachments
              </p>

              <div className="p-2 space-y-3">
                <AttachmentSection
                  title="Delivered Attachments"
                  files={data?.attachments}
                />

                <AttachmentSection
                  title="Received Attachments"
                  files={data?.attachments2}
                />
              </div>
            </div>


            <div className="w-full h-auto flex border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                title="Comments"
                mainId={data?.shippingId}
                addurl={"/shipping-comments/new-comment"}
                geturl={`/shipping-comments/by-Shipping/${data?.shippingId}`}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <img src={selectedImage?.file} alt={selectedImage?.file} />
      </Modal>
    </div>
  );
};
export default ViewShipmentTracking;

const AttachmentSection = ({ title, files }) => {
  return (
    <div>
      <p className="text-xs font-medium text-gray-700 mb-1">
        {title}
      </p>

      <div className="flex flex-wrap gap-2 overflow-y-auto max-h-24">
        {files?.length > 0 ? (
          files.map((file, index) => (
            <FilesView
              key={file?.id ?? index}
              fileView={file}
            />
          ))
        ) : (
          <p className="text-xs text-gray-400">
            No attachments
          </p>
        )}
      </div>
    </div>
  );
};
